// import React from "react";
// import { Link } from "react-router-dom";

// function HeroSectionAbout() {
//   return (
//     <div className="relative overflow-hidden group">
//       <div className="w-full h-auto flex items-center justify-center">
//         <img
//           src="Photos/Photo 1.jpeg"
//           alt="Slide 1"
//           className="h-1/2 object-cover object-center"
//         />
//         <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-20"></div>
//       </div>
//       <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full">
//         <h1 className="text-6xl sm:text-7xl md:text-8xl lg:text-8xl font-bold text-gray-800">
//           About Us
//         </h1>
//       </div>
//     </div>
//   );
// }

// export default HeroSectionAbout;

// import React from "react";

// function HeroSectionAbout() {
//   return (
//     <div className="relative w-full h-[75vh] md:h-[85vh] overflow-hidden">
//       {/* Background Image */}
//       <img
//         src="Photos/Brandflow About Us Hero Section.jpg"
//         alt="About BrandFlow"
//         className="w-full h-full object-cover object-center scale-110 opacity-60"
//       />

//       {/* Animated Gradient Overlay */}
//       <div className="absolute inset-0 bg-gradient-to-b from-[#05050580] via-[#050505a6] to-[#050505] animate-pulse-slow"></div>

//       {/* Glassmorphic Card */}
//       <div className="absolute inset-0 flex items-center justify-center px-4">
//         <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-3xl p-8 md:p-12 max-w-3xl text-center shadow-2xl animate-fade-in">
//           <h1 className="text-4xl sm:text-6xl md:text-7xl font-semibold text-white tracking-tight drop-shadow-lg">
//             About Us
//           </h1>

//           <p className="mt-4 text-base md:text-lg text-white leading-relaxed">
//             Building sustainable growth for Mumbai’s rising startups through
//             marketing, management, collaboration, and innovation.
//           </p>
//         </div>
//       </div>

//       {/* Bottom Soft Fade */}
//       <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#050505] to-transparent"></div>
//     </div>
//   );
// }

// export default HeroSectionAbout;

import React from "react";

function HeroSectionAbout() {
  return (
    <div
      className="relative w-full h-[75vh] md:h-[85vh] overflow-hidden bg-fixed bg-center bg-cover"
      style={{
        backgroundImage: "url('Photos/Brandflow About Us Hero Section.jpg')",
      }}
    >
      {/* Dark Animated Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#05050580] via-[#050505a6] to-[#050505] animate-pulse-slow"></div>

      {/* Glassmorphic Center Card */}
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="backdrop-blur-xl bg-secondary-color/35 border border-white/10 rounded-3xl p-8 md:p-12 max-w-3xl text-center shadow-2xl animate-fade-in">
          <h1 className="text-4xl sm:text-6xl md:text-7xl font-semibold text-white tracking-tight drop-shadow-lg">
            About Brandflow
          </h1>

          <p className="mt-4 text-base md:text-lg text-white leading-relaxed">
            Building sustainable growth for Mumbai’s rising startups through
            marketing, management, collaboration, and innovation.
          </p>
        </div>
      </div>

      {/* Bottom Soft Fade */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#050505] to-transparent"></div>
    </div>
  );
}

export default HeroSectionAbout;
